if (!customElements.get('product-info')) {
  var get_total = 0;
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.mainthis = this;
        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.initCustomizationPopup();
        this.initSizeGuide();
        this.initCustomSize()
       
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

       update_text(){
        console.log("trueee-----");
        const gt_selected_option = parseFloat(sessionStorage.getItem("selected_size_value")) || 0;
        const gt_total_option = parseFloat(sessionStorage.getItem("variant_size")) || 0;
        const tag = sessionStorage.getItem("productTag") || "";
        const selected_size = sessionStorage.getItem("selected_size_value") || "";
        const availableVariant = sessionStorage.getItem("availabelVariant");
        document.querySelector(".info_check_pro").innerHTML = '';
        if (gt_selected_option < gt_total_option) {
          const summaryWrapper = document.querySelector(".info_check_pro");
          if (summaryWrapper) {
            // Prevent duplicate block
            if (!summaryWrapper.querySelector(".infor")) {
              const selectedSizeEl = document.createElement("div");
              selectedSizeEl.className = "infor";
              selectedSizeEl.className = "infor_product";
              var get_availabelVariant = sessionStorage.getItem('availabelVariant');
              if (get_availabelVariant == 'false') {
                selectedSizeEl.innerHTML = `
                  <span>You have selected <strong>${gt_selected_option} meters for ${tag!==''?'for '+ tag:''}</strong></span>
                  <div class="wrp_all">
                  <input type="checkbox" id="accepted_id" class="checkbox_check">
                    <label for="accepted_id">
                      <span>
                        ${tag} will require <strong>${gt_total_option} meters</strong>, which is not currently available.
                        Please confirm by checking the checkbox.
                      </span>
                    </label>
                    </div>
                      <div class="wrp_all">
                    <input type="checkbox" id="accepted_id_2" class="checkbox_check">
                    <label for="accepted_id_2">
                      <span>
                      We are selling Fabrics Only
                      </span>
                    </label>
                  </div>
                `;
              } else {
                selectedSizeEl.innerHTML = `
                <span>You have selected <strong>${gt_selected_option} meters for ${tag!==''?'for '+ tag:''}</strong></span>
                <div class="wrp_all">
                <input type="checkbox" id="accepted_id" class="checkbox_check preselected">
                  <label for="accepted_id">
                    <span>
                      ${tag} will require <strong>${gt_total_option} meters</strong>.
                      Once the fabric is cut, it cannot be exchanged or returned.
                      Please check your size from
                      <a href="/pages/size-chart" target="_blank">this link</a>.
                      </span>
                  </label>
                  </div>
                  <div class="wrp_all">
                  <input type="checkbox" id="accepted_id_2" class="checkbox_check">
                  <label for="accepted_id_2">
                    <span>
                    We are selling Fabrics Only
                    </span>
                  </label>
                  </div>
                `;
              }

              summaryWrapper.prepend(selectedSizeEl);
            }
          }
        } else{
          const summaryWrapper = document.querySelector(".info_check_pro");
          if (!summaryWrapper.querySelector(".infor")) {
              const selectedSizeEl = document.createElement("div");
              selectedSizeEl.className = "infor";
              selectedSizeEl.className = "infor_product";
              selectedSizeEl.innerHTML = `
              <span>You have selected <strong>${selected_size} meters  ${tag!==''?'for '+ tag:''}</strong></span>
                <div class="wrp_all">
                <input type="checkbox" id="accepted_id" class="checkbox_check">
                <label for="accepted_id">
                  <span>
                    Once the fabric is cut, it cannot be exchanged or returned.
                    Please check your size from
                    <a href="/pages/size-chart" target="_blank">this link</a>.
                  </span>
                </label>
                </div>
                <div class="wrp_all">
                <input type="checkbox" id="accepted_id_2" class="checkbox_check">
                  <label for="accepted_id_2">
                    <span>
                    We are selling Fabrics Only
                    </span>
                  </label>
                  </div>
              `;
              summaryWrapper.prepend(selectedSizeEl);
          }

        }
        document.querySelector('.infor_product').style.display = 'block'; 
      }
      
syncVariantToUrl(variantId, productId = null) {
  if (!variantId) return;

  const url = new URL(window.location.href);

  url.searchParams.set('variant', String(variantId));


  if (productId) url.searchParams.set('id', String(productId));

  window.history.replaceState({}, '', url.pathname + url.search + url.hash);
}

      // VAriant Size
/* ===============================
   SIZE OPTIONS
================================ */
adjustOptions(dropdownMenu, plusBtn, optionsList, container, remainingInventory) {
  dropdownMenu.innerHTML = "";

  const containerWidth = container.offsetWidth;
  let usedWidth = plusBtn.offsetWidth + 10;

  const children = [...optionsList.querySelectorAll(".size-option:not(.plus-btn)")];

  // 1️⃣ FILTER BY REMAINING INVENTORY
  children.forEach(child => {
    const sizeValue = parseFloat(child.dataset.varianttitle || "0");

    if (remainingInventory <= 0) {
      // All options visible but disabled
      document.querySelector('#sizeOptions').classList.add('sizeOptions_active');
      child.style.display = "inline-block";
      child.classList.add("disabled-option");
    } else {
       document.querySelector('#sizeOptions').classList.add('sizeOptions_active');
      child.style.display = sizeValue > remainingInventory ? "none" : "inline-block";
      child.classList.remove("disabled-option");
    }
  });

  // 2️⃣ HANDLE OVERFLOW INTO DROPDOWN
  for (let child of children) {
    if (child.style.display === "none") continue;

    const childWidth = child.offsetWidth + 10;
    if (usedWidth + childWidth > containerWidth) {
      child.style.display = "none";

      const li = document.createElement("li");
      li.className = "dropdown-item button_variant";
      li.textContent = child.textContent;
      li.dataset.variant = child.dataset.variant;
      li.dataset.price = child.dataset.price;
      li.dataset.varianttitle = child.dataset.varianttitle;
      li.dataset.availabel = child.dataset.availabel;

      dropdownMenu.appendChild(li);
    } else {
      usedWidth += childWidth;
    }
  }

  plusBtn.style.display = dropdownMenu.children.length ? "inline-block" : "none";
}

/* ===============================
   INITIALIZE CUSTOM SIZE SELECTION
================================ */

initCustomSize() {
  const container = this.querySelector(".size-selection-content");
  const optionsList = this.querySelector("#sizeOptions");
  const plusBtn = this.querySelector("#dropdownToggle");
  const dropdownMenu = this.querySelector("#dropdownMenu");
  const mainThis = this;

  if (!container || !optionsList || !plusBtn || !dropdownMenu) return;

  let remainingInventory = 0;

  // ✅ Save original order ONCE
  if (!optionsList.dataset.originalOrder) {
    optionsList.dataset.originalOrder = JSON.stringify(
      [...optionsList.querySelectorAll(".size-option:not(.plus-btn)")]
        .map(el => el.dataset.variant)
    );
  }
 
  // 🔁 Restore original order (SAFE)
  const restoreOriginalOrder = () => {
    const order = JSON.parse(optionsList.dataset.originalOrder || "[]");
    const optionMap = {};

    optionsList.querySelectorAll(".size-option:not(.plus-btn)").forEach(opt => {
      optionMap[opt.dataset.variant] = opt;
    });
    
    order.forEach(key => {
      if (optionMap[key]) {
        optionsList.appendChild(optionMap[key]);
      }
    });
  };

  const updateOptions = async () => {
    // 🔁 Always reset order first
    restoreOriginalOrder();

    // 1️⃣ Calculate remaining inventory
    let quantityInCart = 0;
    const firstVariant = optionsList.querySelector(".size-option");
    const variantId = firstVariant?.dataset.id;

    if (variantId) {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      var usedInventory = 0;
      

      cart.items
        .filter(item => String(item.product_id) === String(variantId))
        .forEach(item => {
          console.log(item.variant_title,'itemitem');
          const variantSize = parseFloat(item.variant_title.replace('mtr','') || "0");
          usedInventory += item.quantity * variantSize;
        });
    }

    const totalInventory = parseFloat(optionsList.dataset.inventory || "0");
    remainingInventory = Math.max(totalInventory - usedInventory, 0);
    console.log(totalInventory,'orderorder',usedInventory);

    // 2️⃣ Enable or disable options
    const allOptions = [...optionsList.querySelectorAll(".size-option:not(.plus-btn)")];

    // 🚫 WHEN INVENTORY IS FULLY USED → SHOW ALL & DISABLE ALL
    if (remainingInventory <= 0) {
      allOptions.forEach(option => {
        option.classList.add("disabled-option");
        option.style.pointerEvents = "none";
        option.style.opacity = "0.3";
      });

      sessionStorage.setItem("availabelVariant", false);
      plusBtn.classList.add("disabled-option");
      

       requestAnimationFrame(() => {
          mainThis.adjustOptions(
            dropdownMenu,
            plusBtn,
            optionsList,
            container,
            Infinity // 👈 trick: no filtering
          );
        });

        var checkSizeError = setInterval(function () {
        var errorMessage = document.querySelector(".size_error");
        console.log(errorMessage, "errorMessage");

        if (errorMessage) {
          // 👉 Do whatever you need with the element
          errorMessage.style.display = "none";

          // 👉 Stop checking once found
          clearInterval(checkSizeError);
        }
        }, 200);
        
    } 
    // ✅ NORMAL FLOW → ENABLE / DISABLE BASED ON SIZE
    else {
      allOptions.forEach(option => {
        const sizeValue = parseFloat(option.dataset.varianttitle || "0");

        if (sizeValue > remainingInventory) {
          option.classList.add("disabled-option");
          option.style.pointerEvents = "none";
          option.style.opacity = "0.3";
        } else {
          option.classList.remove("disabled-option");
          option.style.pointerEvents = "auto";
          option.style.opacity = "1";
        }
      });

      sessionStorage.setItem("availabelVariant", true);
      plusBtn.classList.remove("disabled-option");
       
    }

    allOptions.forEach(option => {
      const sizeValue = parseFloat(option.dataset.varianttitle || "0");
      if (remainingInventory <= 0 || sizeValue > remainingInventory) {
        option.classList.add("disabled-option");
        option.style.pointerEvents = "none";
        option.style.opacity = "0.3";
      } else {
        option.classList.remove("disabled-option");
        option.style.pointerEvents = "auto";
        option.style.opacity = "1";
      }
    });

    // Edge case: all disabled → enable all
    // if (allOptions.length === optionsList.querySelectorAll(".disabled-option").length) {
    //   allOptions.forEach(option => {
    //     option.classList.remove("disabled-option");
    //     option.style.pointerEvents = "auto";
    //     option.style.opacity = "1";
    //   });
    // }

    // sessionStorage.setItem("availabelVariant", true);
 
    // 3️⃣ Determine selected option
    let savedVariant;

    const productTag = sessionStorage.getItem("productTag");

    if (productTag && productTag.trim() !== "") {
      savedVariant = (sessionStorage.getItem("variant_size") || "").trim();
    } else {
      sessionStorage.setItem("variant_size", "1.00");
      savedVariant = "1.00";
    }

    const enabledOptions = allOptions.filter(
      opt => !opt.classList.contains("disabled-option")
    );
    
    const savedVariantAvailable = enabledOptions.some(
      opt => opt.dataset.varianttitle === savedVariant
    );

    if (savedVariant && !savedVariantAvailable) {
      sessionStorage.setItem("availabelVariant", false);
    }

    let selectedOption = enabledOptions.find(
      opt => opt.dataset.varianttitle === savedVariant
    );

    if (!selectedOption) {
      selectedOption = enabledOptions[0];
    }

    // 4️⃣ No enabled options
    if (!selectedOption) {
      document.querySelector(".selected-size")?.style.setProperty("display", "none");

      mainThis.querySelector(".customization_block")?.classList.add("disabled");
      document.querySelector(".product-form__buttons .product-form__submit")?.setAttribute("disabled", true);

      plusBtn.style.display = "none";
      dropdownMenu.innerHTML = "";

      document.querySelector(".notify_btn")?.style.setProperty("display", "flex");

      sessionStorage.setItem("availabelVariant", false);
      return;
    }

    // 5️⃣ Move selected option to first
    optionsList.prepend(selectedOption);
   

    // 6️⃣ Apply selection
    mainThis.handleSizeSelection(selectedOption, mainThis, remainingInventory);

    // 7️⃣ Adjust dropdown
    mainThis.adjustOptions(
      dropdownMenu,
      plusBtn,
      optionsList,
      container,
      remainingInventory
    );
  };

  // ▶ Initial run
  updateOptions();

  // 🔁 Back/forward cache support (NO reload)
  window.addEventListener("pageshow", e => {
    if (e.persisted) updateOptions();
  });

  // Resize handler
  const adjust = () =>
    mainThis.adjustOptions(dropdownMenu, plusBtn, optionsList, container, remainingInventory);

  window.addEventListener("resize", adjust);

  // Plus button toggle
  plusBtn.addEventListener("click", e => {
    e.stopPropagation();
    mainThis.adjustOptions(dropdownMenu, plusBtn, optionsList, container, remainingInventory);
    dropdownMenu.style.display =
      dropdownMenu.style.display === "block" ? "none" : "block";
  });

  // Option click
  this.querySelectorAll(".size-option:not(.plus-btn)").forEach(option => {
    option.addEventListener("click", e => {
      e.stopPropagation();
      if (!option.classList.contains("disabled-option")) {
        mainThis.handleSizeSelection(option, mainThis, remainingInventory);
        document.querySelector(".size_error")?.style.setProperty("display", "none");
      }
    });
  });

  // Dropdown click
  dropdownMenu.addEventListener("click", e => {
    const item = e.target.closest(".dropdown-item");
    if (!item || item.classList.contains("disabled-option")) return;
    e.stopPropagation();
    mainThis.handleSizeSelection(item, mainThis, remainingInventory);
    dropdownMenu.style.display = "none";
  });

  // Outside click closes dropdown
  document.addEventListener("click", e => {
    if (!plusBtn.contains(e.target) && !dropdownMenu.contains(e.target)) {
      dropdownMenu.style.display = "none";
    }
  });
}


/* ===============================
   REORDER OPTIONS KEEP SELECTED FIRST
================================ */
reorderOptionsKeepSelectedFirst(selectedOption, optionsList, remainingInventory) {
  const originalOrder = JSON.parse(optionsList.dataset.originalOrder || "[]");
  const selectedVariant = selectedOption.dataset.variant;

  const sizeOptions = [...optionsList.querySelectorAll(".size-option:not(.plus-btn)")];
  const optionMap = {};
  sizeOptions.forEach(opt => optionMap[opt.dataset.variant] = opt);
  sizeOptions.forEach(opt => opt.remove());

  const plusBtn = optionsList.querySelector(".plus-btn");

  if (optionMap[selectedVariant]) {
    optionsList.insertBefore(optionMap[selectedVariant], plusBtn);
  }

  originalOrder.forEach(variantId => {
    if (variantId !== selectedVariant && optionMap[variantId]) {
      const sizeValue = parseFloat(optionMap[variantId].dataset.varianttitle || "0");
      if (sizeValue <= remainingInventory) {
        optionsList.insertBefore(optionMap[variantId], plusBtn);
      }
    }
  });
}

/* ===============================
   HANDLE SIZE SELECTION
================================ */
handleSizeSelection(target, mainThis, remainingInventory) {
  const selectedSize = mainThis.querySelector(".selected-size");
  const optionsList = mainThis.querySelector("#sizeOptions");
  const dropdownMenu = mainThis.querySelector("#dropdownMenu");
  const plusBtn = mainThis.querySelector("#dropdownToggle");
  const container = mainThis.querySelector(".size-selection-content");

  const variantId = target.dataset.variant;
  const price = target.dataset.price;
  const variantTitle = target.dataset.varianttitle;
  const variantavailabel = target.dataset.availabel;

  mainThis.querySelectorAll(".size-option, .dropdown-item").forEach(el => el.classList.remove("active"));

  selectedSize.textContent = target.textContent;
  selectedSize.style.display = "contents";

  const customizeBtn = mainThis.querySelector(".customization_block");
  const addToCartBtn = document.querySelector(".product-form__buttons .product-form__submit");

  if (variantavailabel == false || remainingInventory <= 0) {
    customizeBtn.classList.add("disabled");
    addToCartBtn.setAttribute("disabled", true);
    document.querySelector(".notify_btn").style.display = "flex";
  } else {
    customizeBtn.classList.remove("disabled");
    addToCartBtn.removeAttribute("disabled");
    addToCartBtn.classList.remove("disabled");
    document.querySelector(".notify_btn").style.display = "none";
  }

  if (variantTitle === "1.00") {
    document.querySelectorAll(".per_mt").forEach(el => (el.style.display = "block"));
    document.querySelectorAll(".our_rate").forEach(el => (el.style.display = "none"));
    document.querySelectorAll(".our_rate_text").forEach(el => (el.style.display = "none"));
    document.querySelectorAll(".price").forEach(el => (el.style.display = "flex"));
  } else {
    document.querySelectorAll(".per_mt").forEach(el => (el.style.display = "none"));
    document.querySelectorAll(".our_rate").forEach(el => (el.style.display = "block"));
    document.querySelectorAll(".our_rate_text").forEach(el => (el.style.display = "block"));
    document.querySelectorAll(".price").forEach(el => (el.style.display = "flex"));
  }

  if (!sessionStorage.getItem("productTag") || sessionStorage.getItem("productTag") == '') {
    sessionStorage.setItem("variant_size", '1.00');
    sessionStorage.setItem("selected_size_value", variantTitle || target.textContent);
  }else{
    sessionStorage.setItem("selected_size_value", variantTitle || target.textContent);
  }

  sessionStorage.setItem("customVariantPrice", price);
  
  sessionStorage.setItem("customVariantId", variantId);

  const salePriceEl = mainThis.querySelector(".price__sale .price-item--sale");
  if (salePriceEl) salePriceEl.innerHTML = price;
  console.log(price,'priceprice');
  const regularPriceEl = mainThis.querySelector(".price_desktop .price-item--regular");
  if (regularPriceEl) regularPriceEl.innerHTML = price;
  mainThis.querySelector(".price-item--regular").innerHTML =  price;
  const variantInput = mainThis.querySelector(".product-variant-id");
  if (variantInput) variantInput.value = variantId;

  let newOption = target;
  if (target.classList.contains("dropdown-item")) {
    newOption = optionsList.querySelector(`.size-option[data-variant="${variantId}"]`);
  }

  newOption.classList.add("active");

  const quantityInput = document.querySelector(".price-per-item__container .quantity__input");
  quantityInput.value = 1;
  quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
  quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
  document.querySelector("#quantityError").setAttribute("hidden", "");

  this.reorderOptionsKeepSelectedFirst(newOption, optionsList, remainingInventory);
  this.adjustOptions(dropdownMenu, plusBtn, optionsList, container, remainingInventory);

  const productInfo = target.closest('product-info');
  const shouldUpdateUrl =
    productInfo &&
    productInfo.dataset.updateUrl !== 'false' &&
    !target.closest('.quick-add-modal');

  if (shouldUpdateUrl) {
    const productIdForUrl = target.dataset.id || null;
    mainThis.syncVariantToUrl(variantId);
  }
   mainThis.update_text();
}

      // Variant Size End

      initSizeGuide() {
        const overlay = this.querySelector(".size-chart-overlay");
        const guideLink = this.querySelector(".size-guide-link");
        const downThis = this;

        guideLink.addEventListener("click", function (e) {
          e.preventDefault();
          downThis.querySelectorAll(".size-chart-wrapper").forEach(wrapper => {
            wrapper.classList.remove("active");
          });
          const chartToShow = downThis.querySelector('.size-chart-wrapper');
          if (chartToShow) {
            chartToShow.classList.add("active");
          }
          overlay.classList.add("active");
        });

        this.querySelectorAll('.size-chart-close').forEach((btn) => {
          btn.addEventListener('click', () => {
            document.querySelectorAll('.size-chart-wrapper').forEach((c) => c.classList.remove('active'));
            overlay.classList.remove('active');
          });
        });

        // Close when clicking overlay
        overlay.addEventListener('click', () => {
          document.querySelectorAll('.size-chart-wrapper').forEach((c) => c.classList.remove('active'));
          overlay.classList.remove('active');
        });
      }

      initCustomizationPopup() {
        const popupTrigger = this.querySelector(".popup-tags-wrapper");
        const customization_text = this.querySelector(".customization_block");
        const popup = this.querySelector(".product-tags-popup");
        const closeBtn = this.querySelector(".popup-close");

        var get_tagName = sessionStorage.getItem("productTag");
        if(!window.location.href.includes('#view=') || window.location.href.includes('#view=') == false){
          sessionStorage.setItem('productTag','');
          document.querySelector('.customize-categories').innerText= 'Personalise Your Style';
        } else {
          var get_tag = window.location.href.split('#view=')[1];
          if(get_tag != '') {
            document.querySelector('.customize-categories').innerText= 'Personalise Your Style';
          } else {
            sessionStorage.setItem('productTag','');
            document.querySelector('.customize-categories').innerText= 'Personalise Your Style';
          }
        }

        if (popupTrigger && popup) {
          popupTrigger.addEventListener("click", (e) => {
            e.preventDefault();
            var get_tag = sessionStorage.getItem("productTag");
            var get_selected_size = parseFloat(sessionStorage.getItem("selected_size_value"));
            if(get_tag == ''){
              popup.classList.remove("hidden");
            } else {
              if(get_tag == 'suit') { 
                sessionStorage.setItem("multi_tag", 'suit,pant');
                if(get_selected_size < 3.50){
                  sessionStorage.setItem("variant_size",'3.50');
                }
              }else if(get_tag == 'pant') {
                sessionStorage.setItem("multi_tag", 'pant');
                if(get_selected_size < 1.30){
                  console.log('get_tagget_tag');
                  sessionStorage.setItem("variant_size",'1.30');
                }
              }else if(get_tag == '3-piece-suit') { 
                sessionStorage.setItem("multi_tag", 'suit,pant,koti'); 
                sessionStorage.setItem("productTag", '3-piece-suit'); 
                if(get_selected_size < 4.30){
                  sessionStorage.setItem("variant_size",'4.30');
                }
               
              } else if(get_tag == 'koti') { 
                sessionStorage.setItem("multi_tag", 'koti'); 
                sessionStorage.setItem("productTag", 'koti'); 
                
                if(get_selected_size < 1.30){
                  sessionStorage.setItem("variant_size",'1.30');
                }
               
              }else if(get_tag == 'indiankoti') { 
                sessionStorage.setItem("multi_tag", 'indiankoti'); 
                sessionStorage.setItem("productTag", 'indiankoti'); 
                if(get_selected_size < 1.30){
                  sessionStorage.setItem("variant_size",'1.30');
                }
               
              } else if(get_tag == 'jodhpuri') { 
                sessionStorage.setItem("multi_tag", 'jodhpuri,pant'); 
                sessionStorage.setItem("productTag", 'jodhpuri');
                if(get_selected_size < 3.50){
                  sessionStorage.setItem("variant_size",'3.50');
                }
               
              } else if(get_tag == 'blazer') { 
                 sessionStorage.setItem("multi_tag", 'suit'); 
                 sessionStorage.setItem("productTag", 'blazer');  
                if(get_selected_size < 2.30){
                  sessionStorage.setItem("variant_size",'2.30');
                }
               
              } else if(get_tag == 'shirt') { 
                sessionStorage.setItem("multi_tag", 'shirt'); 
                sessionStorage.setItem("productTag", 'shirt'); 
                sessionStorage.setItem("variant_size",'1.70');
                if(get_selected_size < 1.70){
                  sessionStorage.setItem("variant_size",'1.70');
                }
              
              } else if(get_tag == 'indowestern') { 
                sessionStorage.setItem("multi_tag", 'indowestern'); 
                sessionStorage.setItem("productTag", 'indowestern');
                if(get_selected_size < 2.50){
                  sessionStorage.setItem("variant_size",'2.50');
                }
                
              }else if(get_tag == 'kurta') { 
                sessionStorage.setItem("multi_tag", 'kurta'); 
                sessionStorage.setItem("productTag", 'kurta');
                if(get_selected_size < 1.30){
                  sessionStorage.setItem("variant_size",'2.30');
                } 
              }else if(['jacket','jackets','shacket','shaket','scaket'].includes(String(get_tag||'').toLowerCase())) { 
                const jt = String(get_tag||'').toLowerCase();
                sessionStorage.setItem("multi_tag", jt); 
                sessionStorage.setItem("productTag", jt);
                if(get_selected_size < 1.30){
                  sessionStorage.setItem("variant_size",'2.30');
                } 
              }
                document.querySelector(".product-tags-popup .customization_link").click();
            }
          });
        }

        if (closeBtn) {
          closeBtn.addEventListener("click", () => { 
            popup.classList.add("hidden"); 
          });
        }

        document.querySelectorAll(".customization_link").forEach(link => {
          link.addEventListener("click", function(event) {
              event.preventDefault();
              const handle = this.dataset.product_handle;
              const variantId = document.querySelector('.button_variant.active').dataset.variant; 
              const variantPrice = document.querySelector('.button_variant.active').dataset.price; 
              const productId = document.querySelector('.button_variant.active').dataset.id;
              const checkedRadio = document.querySelector('input[name="tags_customize"]:checked');
              const getTag = sessionStorage.getItem("productTag")?.trim() || ""; 
               const getSize = sessionStorage.getItem("variant_size")?.trim() || ""; 
              if(checkedRadio !== null){
                var productTag = checkedRadio ? checkedRadio.value : null;
              }else{
                 var productTag = getTag;
              }
              var get_total_inventory = document.querySelector('#sizeOptions').getAttribute('data-inventory');
              sessionStorage.setItem("Total",get_total_inventory);
              if (handle) sessionStorage.setItem("customProductHandle", handle); 
              if (variantId) sessionStorage.setItem("customVariantId", variantId);
              if (variantPrice) sessionStorage.setItem("customVariantPrice", variantPrice); 
              if (productId) sessionStorage.setItem("productId", productId); 
              if (productTag) sessionStorage.setItem("productTag", productTag);
              if(document.querySelector('.size-option.active').getAttribute('data-varianttitle') != getSize){
                if(document.querySelector('.size-option[data-varianttitle="'+ getSize +'"]') !== null){
                  var get_option_id = document.querySelector('.size-option[data-varianttitle="'+ getSize +'"]').getAttribute('data-variant');
                  sessionStorage.setItem("PreselectedOption",get_option_id );
                }
              }
              if(checkedRadio !== null){
                var get_selected_size = parseFloat(checkedRadio.dataset.tag);
                sessionStorage.setItem("variant_size",get_selected_size);
              }
                
              if(productTag == 'suit') {
                sessionStorage.setItem("multi_tag", 'suit,pant');
              }else if(productTag == 'blazer') {
                sessionStorage.setItem("multi_tag", 'suit');
              }else if(productTag == 'pant') {
                sessionStorage.setItem("multi_tag", 'pant');
              } else if(productTag == '3-piece-suit') {
                sessionStorage.setItem("multi_tag", 'suit,pant,koti'); 
                sessionStorage.setItem("productTag", '3-piece-suit');
              } else if(productTag == 'koti') {
                sessionStorage.setItem("multi_tag", 'koti'); 
                sessionStorage.setItem("productTag", 'koti');
              } else if(get_tag == 'indiankoti') { 
                sessionStorage.setItem("multi_tag", 'indiankoti'); 
                sessionStorage.setItem("productTag", 'indiankoti'); 
              } else if(productTag == 'jodhpuri') {
                sessionStorage.setItem("multi_tag", 'jodhpuri,pant'); 
                sessionStorage.setItem("productTag", 'jodhpuri');
              } else if(productTag == 'blazer') {
                 sessionStorage.setItem("multi_tag", 'suit'); 
                sessionStorage.setItem("productTag", 'blazer'); 
              } else if(productTag == 'shirt') {
                sessionStorage.setItem("multi_tag", 'shirt'); 
                sessionStorage.setItem("productTag", 'shirt');
              } else if(productTag == 'indowestern') {
                sessionStorage.setItem("multi_tag", 'indowestern'); 
                sessionStorage.setItem("productTag", 'indowestern');
              }else if(productTag == 'kurta') { 
                sessionStorage.setItem("multi_tag", 'kurta'); 
                sessionStorage.setItem("productTag", 'kurta'); 
              }else if(['jacket','jackets','shacket','shaket','scaket'].includes(String(productTag||'').toLowerCase())) { 
                const jt = String(productTag||'').toLowerCase();
                sessionStorage.setItem("multi_tag", jt); 
                sessionStorage.setItem("productTag", jt); 
              }
               var get_tag = sessionStorage.getItem("productTag");
              if(get_tag != ''){
                window.location.href = "/pages/customization-page";
              }else{
                document.querySelector('.tags-customize').insertAdjacentHTML('afterend', '<p>Please Select Option</p>');
              }
            console.log("Customization Link Clicked → LocalStorage updated ✅");
          });
        });
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
            const updateId = html.querySelector('.customize-button').getAttribute('data-id');
            const updateVariantId = html.querySelector('.customize-button').getAttribute('data-variant');
            const updatePrice = html.querySelector('.customize-button').getAttribute('data-price');
            document.querySelector('.customize-button')?.setAttribute('data-id', updateId);
            document.querySelector('.customize-button')?.setAttribute('data-price', updatePrice);
            document.querySelector('.price__sale .price-item--sale').innerHTML = updatePrice;
            document.querySelector('.price_desktop .price-item--regular').innerHTML = updatePrice;
            sessionStorage.setItem("customVariantPrice", updatePrice);
            sessionStorage.setItem("customVariantId", updateVariantId);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
